import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Button } from '@material-ui/core';
import { newPostValidation } from '../../../models/survey/SurveySubmissionValidation';
import FormTextField from '../../form/FormTextField';
import BoardPostGalleryFormItem from './BoardPostGalleryFormItem';
import BoardPostFilesFormItem from './BoardPostFilesFormItem';

const BoardPostEditor = ({ t, onSubmit, disabled }) => {
  return (
    <Form
      onSubmit={onSubmit}
      validate={newPostValidation}
      mutators={{
        ...arrayMutators
      }}
      render={({ handleSubmit, invalid, submitting, form }) => (
        <form onSubmit={event => {
          handleSubmit(event).then(() => form.reset());
        }}>
          <div>
            <Field
              name="content"
              component={FormTextField}
              label={t('boardThreadDetails.form.contentLabel')}
              placeholder={t('boardThreadDetails.form.contentPlaceholder')}
              fullWidth
              multiline
              rows={4}
              disabled={disabled}
            />
          </div>
          <div>
            <BoardPostGalleryFormItem disabled={disabled || submitting} />
          </div>
          <div>
            <BoardPostFilesFormItem disabled={disabled || submitting} />
          </div>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={disabled || invalid || submitting}
            style={{ marginTop: 20 }}
          >
            {t('boardThreadDetails.form.submitButton')}
          </Button>
        </form>
      )}
    />
  );
};

BoardPostEditor.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default translate()(BoardPostEditor);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPostEditor.js